import React, { Fragment, forwardRef } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import NativeListener from 'react-native-listener'
import { compose } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'

import messages from './messages'
import s from './SearchInput.scss'


const SearchInput = forwardRef(({ className, value, isOpened, isMobile, onChange, onFocus, onCancel }, ref) => {
  const inputClassName = cx(className, s.input, { [s.open]: isOpened })
  const closeArrowClassName = cx(s.closeArrow, { [s.open]: isOpened })

  const searchInputNode = (
    <input
      id="searchInput"
      ref={ref}
      className={inputClassName}
      type="text"
      value={value}
      placeholder={messages.placeholder}
      onChange={onChange}
      onFocus={onFocus}
      autoComplete="nope"
    />
  )

  // form with non-empty action is required by iOS 9+ to change keyboard type to 'Search'
  return (
    <Fragment>
      {
        isMobile && <button className={closeArrowClassName} onClick={onCancel} type="button" />
      }
      <NativeListener onClick={(event) => event.stopPropagation()}>
        {
          isMobile ? (
            <form
              action="."
              onSubmit={(event) => {
                event.preventDefault()
                return false
              }}
              autoComplete="nope"
            >
              {searchInputNode}
            </form>
          ) : (
            searchInputNode
          )
        }
      </NativeListener>
    </Fragment>
  )
})

SearchInput.displayName = `ForwardRef(SearchInput)`

SearchInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  isOpened: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onCancel: PropTypes.func,

  // @injectGlobals
  isMobile: PropTypes.bool,
}


export default compose(
  injectGlobals(({ globals }) => ({
    isMobile: globals.device.isMobile,
  })),
)(SearchInput)
